import { usePostTablesRoles } from '@ipfabric/api-client/client/model/rbac-—-roles/rbac-—-roles';
import type { SelectOptionType } from 'components/Select/SelectOption';
import { useMemo } from 'react';
import { useTableQueryWithMandatoryColumns } from 'utils/table/useTableQueryWithMandatoryColumns';

export const useRolesOptions = (): SelectOptionType<string>[] | null => {
  const rolesQueryRaw = usePostTablesRoles({ columns: ['id', 'name'] });
  const rolesQuery = useTableQueryWithMandatoryColumns(
    ['id', 'name'],
    rolesQueryRaw,
  );

  return useMemo(
    () =>
      rolesQuery.data?.data.map((role) => ({
        value: role.id,
        label: role.name,
      })) ?? null,
    [rolesQuery.data],
  );
};
